import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://oasqmdrlecjjkawbqlnj.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9hc3FtZHJsZWNqamthd2JxbG5qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY0NjI4NjcsImV4cCI6MjA2MjAzODg2N30.iVvJMrPBgvbh3p_4yTu2U2jyy7whNBQpsZ2_Rt-14-8';

export const supabase = createClient(supabaseUrl, supabaseKey);

// Initialize database - create tables if they don't exist
export async function initializeDatabase() {
  try {
    // Initialize contact_submissions table
    await initializeTable('contact_submissions', 'create_contact_table');
    
    // Initialize article_feedback table
    await initializeTable('article_feedback', 'create_article_feedback_table');
    
    return { success: true };
  } catch (error) {
    console.error('Error initializing database:', error);
    return { success: false, error };
  }
}

// Helper function to initialize a specific table
async function initializeTable(tableName: string, rpcFunctionName: string) {
  // First, check if the table already exists
  const { data: tableExists, error: tableCheckError } = await supabase
    .from(tableName)
    .select('id')
    .limit(1);
  
  // If the table exists, we don't need to create it
  if (!tableCheckError || tableExists) {
    console.log(`Table ${tableName} already exists`);
    return { success: true };
  }
  
  console.log(`Table ${tableName} doesn't exist, attempting to create it...`);
  
  // Method 1: Use a stored procedure if it exists
  const { error: rpcError } = await supabase.rpc(rpcFunctionName, {});
  
  if (!rpcError) {
    console.log(`Successfully created ${tableName} table using RPC`);
    return { success: true };
  }
  
  console.log(`RPC method failed for ${tableName}, trying SQL execution`);
  
  // Method 2: Use the SQL from supabase-setup.sql file
  // You should copy this file to your Supabase SQL editor and run it manually
  // if automatic creation fails
  
  console.error(`Could not create ${tableName} table automatically.`);
  console.error(`Please create the ${tableName} table manually in the Supabase dashboard using the SQL in src/services/supabase-setup.sql`);
  
  return { 
    success: false, 
    error: `Could not auto-create ${tableName} table`,
    manual_instructions: `Please create the ${tableName} table in Supabase dashboard using the SQL in src/services/supabase-setup.sql`
  };
} 